import { Paper } from '@common/ui'
import { com } from '@eidu/web'
import Description = com.eidu.sharedlib.form.definition.Description
import { withKey } from '../../util/withKey'
import TrimmedTextArea from './TrimmedTextArea'

type DescriptionItemProps = {
  item: Description
  onChange?: (newItem: Description) => void
  onDelete?: () => void
}

const DescriptionItem: React.FC<DescriptionItemProps> = ({ item, onChange }) => (
  <Paper withBorder radius="sm" p="xs">
    <TrimmedTextArea
      value={item.text}
      onChange={(e) => onChange?.(withKey(item.copy(e.target.value), item))}
      placeholder="Enter description"
      disabled={!onChange}
      autosize
    />
  </Paper>
)

export default DescriptionItem
